import UpsellCheckboxCondensed from './UpsellCheckboxCondensed';
import UpsellCheckboxExpanded from './UpsellCheckboxExpanded';

// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
Compliance.propTypes = {
  item: PropTypes.object.isRequired,
  prefix: PropTypes.string,
};

export default function Compliance({ item, prefix }) {
  const accessoryUpsells = item.upSellProducts
    .filter((upsell) => upsell.upsellSectionId === 2)
    .sort((a, b) => a.upsellOrderIndex - b.upsellOrderIndex);

  const optionalItems = accessoryUpsells.slice(1, accessoryUpsells.length - 1).map((upsell) => {
    return <UpsellCheckboxCondensed item={item} upsell={upsell} prefix={prefix} key={upsell.productId} />;
  });

  const classificationUpsell = accessoryUpsells.slice(-1)[0];

  const hasUpgrades = accessoryUpsells.length > 0;

  return (
    <>
      {hasUpgrades && (
        <div className="upsell-group">
          {accessoryUpsells.length > 3 && optionalItems.length && (
            <div className="optional-items">
              <h3 className="fs-3 fw-500 mb-3">Compliance and Optional Items</h3>
              <p>
                Listed below are a few additional items that we offer for new companies. To add any of these items to your
                order, simply check the box next to the item(s) you need.
              </p>
              {optionalItems}
            </div>
          )}

          {accessoryUpsells.length > 3 && classificationUpsell && (
            <div className="optional-items">
              <h3 className="fs-3 fw-500 mt-5 mb-3">Entity Classification</h3>
              <UpsellCheckboxExpanded item={item} upsell={classificationUpsell} prefix={prefix} />
            </div>
          )}
        </div>
      )}
    </>
  );
}
